import { Directive, TemplateRef, Input, ViewContainerRef } from '@angular/core';
import { Subject } from 'rxjs';

export type SwiperOrientation = 'horizontal' | 'vertical';

export interface Slide {
    key: string;
    doShow?: boolean;
    hidePagination?: boolean;
    templateRef?: TemplateRef<SwiperSlideDirective>;
}

@Directive({
    selector: '[slide]'
})
export class SwiperSlideDirective {
    public options: Slide;

    @Input() set slide(opt: Slide) {
        // Save slide options from template init
        this.options = opt || { key: null };
    }

    constructor(private viewContainer: ViewContainerRef, public templateRef: TemplateRef<any>) {
    }

    ngOnInit() {

    }
}

@Directive({
    selector: '[slideTemplate]'
})
export class SwiperSlideTemplateDirective {
    constructor() { }
}
